export var SelectMode;
(function (SelectMode) {
    SelectMode["default"] = "default";
    SelectMode["multiple"] = "multiple";
    SelectMode["tags"] = "tags";
    SelectMode["combobox"] = "combobox";
})(SelectMode || (SelectMode = {}));
